import React from 'react';
import {
  Box, FormControl, InputLabel, Select, MenuItem, OutlinedInput, Chip, Typography
} from '@mui/material';

export default function FiltersBar({
  filters,
  areaOptions,
  liderOptions,
  periodOptions,
  onFilterChange
}) {
  return (
    <Box mb={4}>
      <Typography variant="subtitle1" sx={{ mb: 1, fontWeight: 'bold' }}>Filtrar por:</Typography>
      <Box display="flex" flexWrap="wrap" gap={2}>
        {/* Period Filter (single select) */}
        <FormControl sx={{ minWidth: 150 }} size="small">
          <InputLabel>Período</InputLabel>
          <Select
            value={filters.period}
            label="Período"
            onChange={(e) => onFilterChange('period', e.target.value)}
          >
            <MenuItem value="">Todos</MenuItem>
            {periodOptions.map(option => (
              <MenuItem key={option} value={option}>{option}</MenuItem>
            ))}
          </Select>
        </FormControl>

        {/* Area Filter (multi-select) */}
        <FormControl sx={{ minWidth: 200 }} size="small">
          <InputLabel>Área</InputLabel>
          <Select
            key={JSON.stringify(filters.area)}
            multiple // Enable multi-select
            value={filters.area || []} // Ensure value is an array
            onChange={(e) => {
              const value = e.target.value;
              if (value.includes("")) { // If "Todas" (empty string) is selected, it means clear all
                onFilterChange('area', []);
              } else {
                onFilterChange('area', value);
              }
            }}
            input={<OutlinedInput label="Área" />}
            renderValue={(selected) => ( // Render selected chips
              <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                {selected.length === 0 ? <em>Todas</em> : selected.map((value) => (
                  <Chip key={value} label={value} size="small" onDelete={() => {
                    const newArea = [...selected];
                    const index = newArea.indexOf(value);
                    if (index > -1) {
                      newArea.splice(index, 1);
                    }
                    onFilterChange('area', newArea);
                  }} />
                ))}
              </Box>
            )}
          >
            <MenuItem value=""> 
              <em>Todas</em>
            </MenuItem>
            {areaOptions.map(option => (
              <MenuItem key={option} value={option}>{option}</MenuItem>
            ))}
          </Select>
        </FormControl>

        {/* Líder Filter (multi-select) */}
        <FormControl sx={{ minWidth: 200 }} size="small">
          <InputLabel>Líder</InputLabel>
          <Select
            key={JSON.stringify(filters.lider)}
            multiple // Enable multi-select
            value={filters.lider || []} // Ensure value is an array
            onChange={(e) => {
              const value = e.target.value;
              if (value.includes("")) { // If "Todos" (empty string) is selected, it means clear all
                onFilterChange('lider', []);
              } else {
                onFilterChange('lider', value);
              }
            }}
            input={<OutlinedInput label="Líder" />}
            renderValue={(selected) => (
              <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                {selected.length === 0 ? <em>Todos</em> : selected.map((value) => (
                  <Chip key={value} label={value} size="small" onDelete={() => {
                    const newLider = [...selected];
                    const index = newLider.indexOf(value);
                    if (index > -1) {
                      newLider.splice(index, 1);
                    }
                    onFilterChange('lider', newLider);
                  }} />
                ))}
              </Box>
            )}
          >
            <MenuItem value=""> 
              <em>Todos</em>
            </MenuItem>
            {liderOptions.map(option => (
              <MenuItem key={option} value={option}>{option}</MenuItem>
            ))}
          </Select>
        </FormControl>
      </Box>
    </Box>
  );
} 